module.exports = __webpack_public_path__ + "img/score_verysad.46d6b2c0.png";